var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.getClassName,attrs:{"src":require(`@/assets/icons/${_vm.name}.svg`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }